export function isGltf(src?: string): src is string {
  if (!src) return false;
  return /\.(gltf|glb)$/.test(src);
}
